import React from 'react';
import { useTranslation } from 'react-i18next';

// "Secure payments powered by Stripe" trust block shown under Add to Cart.
// h = logo height as a share of the tile, so wide wordmarks and square marks look balanced.
const LOGOS = [
  { src: '/images/payments/visa.svg', alt: 'Visa', h: 34 },
  { src: '/images/payments/mastercard.svg', alt: 'Mastercard', h: 62 },
  { src: '/images/payments/amex.svg', alt: 'American Express', h: 72 },
  { src: '/images/payments/discover.svg', alt: 'Discover', h: 22 },
  { src: '/images/payments/jcb.svg', alt: 'JCB', h: 60 },
  { src: '/images/payments/unionpay.svg', alt: 'UnionPay', h: 64 },
  { src: '/images/apple-pay.svg', alt: 'Apple Pay', h: 40 },
  { src: '/images/gpay.svg', alt: 'Google Pay', h: 40 },
];

const Line = ({ children }) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    {children}
  </svg>
);

const LockShield = () => (
  <Line>
    <path d="M12 3l7 3v5c0 4.6-3 8.4-7 10-4-1.6-7-5.4-7-10V6z" />
    <rect x="9" y="11" width="6" height="5" rx="1" />
    <path d="M10.2 11V9.6a1.8 1.8 0 0 1 3.6 0V11" />
  </Line>
);
const Lock = () => (
  <Line>
    <rect x="5" y="10.5" width="14" height="10" rx="2" />
    <path d="M8 10.5V7.5a4 4 0 0 1 8 0v3M12 14.5v2" />
  </Line>
);
const ShieldCheck = () => (
  <Line>
    <path d="M12 3l7 3v5c0 4.6-3 8.4-7 10-4-1.6-7-5.4-7-10V6z" />
    <path d="M9 12l2 2 4-4" />
  </Line>
);
const Card = () => (
  <Line>
    <rect x="3" y="5.5" width="18" height="13" rx="2" />
    <path d="M3 10h18M7 15h4" />
  </Line>
);

const LinkLogo = () => (
  <span className="r4l-sp-link" aria-label="Link by Stripe" role="img">
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <circle cx="12" cy="12" r="12" fill="#00D66F" />
      <path d="M9 6.5h3.4l5 5.5-5 5.5H9l5-5.5z" fill="#011E0F" />
    </svg>
    <span>
      <b>link</b>
      <small>by <strong>stripe</strong></small>
    </span>
  </span>
);

export default function SecurePayments() {
  const { t } = useTranslation();

  return (
    <div className="r4l-sp">
      <div className="r4l-sp-head">
        <span className="r4l-sp-badge"><LockShield /></span>
        <p className="r4l-sp-title">
          <b>{t('r4l.detail.trust2')}</b> <span>{t('r4l.detail.payPowered')}</span>{' '}
          <img src="/images/payments/stripe.svg" alt="Stripe" className="r4l-sp-stripe" />
        </p>
        <ul className="r4l-sp-points">
          <li><Lock /><span>{t('r4l.detail.payEncrypted')}</span></li>
          <li><ShieldCheck /><span>{t('r4l.detail.payData')}</span></li>
          <li><Card /><span>{t('r4l.detail.payTrusted')}</span></li>
        </ul>
      </div>

      <ul className="r4l-sp-logos">
        {LOGOS.map((logo) => (
          <li key={logo.alt}>
            <img src={logo.src} alt={logo.alt} loading="lazy" style={{ height: `${logo.h}%` }} />
          </li>
        ))}
        <li><LinkLogo /></li>
        <li className="r4l-sp-more" aria-label={t('r4l.detail.payMore')}>
          <span aria-hidden="true">•••</span>
          + {t('r4l.detail.payMore')}
        </li>
      </ul>

      <p className="r4l-sp-note">{t('r4l.detail.payNote')}</p>
    </div>
  );
}
